import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { isIOS } from "../utils/device";
import "./IOSInstallHint.css";

const IOSInstallHint: React.FC = () => {
  const [visible, setVisible] = useState(true);

  if (!isIOS() || !visible) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="ios-hint"
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        transition={{ duration: 0.4 }}
      >
        <div className="ios-hint-content">
          <span>
            Install Gelwel: Tap <strong>Share</strong> → <strong>Add to Home Screen</strong>
          </span>
          <button onClick={() => setVisible(false)}>✕</button>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default IOSInstallHint;
